export default "__VITE_ASSET__DDJNWti4__"